(ns practitest.frontend.login.reset-password-views
  (:require
   [practitest.frontend.login.events :as events]
   [practitest.frontend.login.subs :as subs]
   [practitest.frontend.login.views :as login-views]
   [practitest.frontend.components.icons :as icons]
   [practitest.frontend.components2.spinners :as spinners]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]))

(defn- error-box [error]
  (when error
    [:div.error error]))

(defn- submit-button [text loading?]
  [:button.submit
   {:type     "submit"
    :disabled loading?}
   (if loading?
     [spinners/mux-spinner {:size :small :fade-in? false}]
     text)])

(defn- password-field [{:keys [value on-change placeholder disabled? auto-focus?]}]
  (let [show? (reagent/atom false)]
    (fn [{:keys [value on-change placeholder disabled? auto-focus?]}]
      [:div.field.field--password
       [:input.m-input
        {:type          (if @show? "text" "password")
         :placeholder   placeholder
         :auto-focus    auto-focus?
         :aria-label    placeholder
         :disabled      disabled?
         :auto-complete "new-password"
         :value         value
         :on-change     #(on-change (.. % -target -value))}]
       [:button.eye-btn
        {:type       "button"
         :aria-label (if @show?
                       (get-translation "login.hide-password" "Hide password")
                       (get-translation "login.show-password" "Show password"))
         :on-click   #(swap! show? not)}
        (if @show? [icons/mux-eye-off] [icons/mux-eye])]])))

(defn reset-password-page [_route]
  (let [password              (reagent/atom "")
        password-confirmation (reagent/atom "")
        verification-code     (reagent/atom "")
        error                 (re-frame/subscribe [::subs/error])
        loading?              (re-frame/subscribe [::subs/loading?])
        reset-code            (re-frame/subscribe [::subs/reset-code])]
    (fn [_route]
      (let [cognito? (= @reset-code "code")]
        [:div.login-page
         [login-views/left-panel]
         [:div.right
          [:div.right-inner
           [:div.form-title
            (get-translation "login.reset-password.title" "Reset your password")]
           [:p.forgot-password-description
            (get-translation "login.reset-password.description"
                             "Please type your new password. Passwords are case sensitive.")]
           [:form.form
            {:on-submit (fn [e]
                          (.preventDefault e)
                          (re-frame/dispatch [::events/submit-reset-password
                                              @password
                                              @password-confirmation
                                              (when cognito? @verification-code)]))}
            [password-field {:value       @password
                             :on-change   #(reset! password %)
                             :placeholder (get-translation "login.reset-password.password-label" "Password")
                             :disabled?   @loading?
                             :auto-focus? true}]
            [:p.hint
             (get-translation "login.reset-password.password-hint"
                              "8-40 chars · 1 uppercase · 1 lowercase · 1 digit · 1 special char")]
            [password-field {:value       @password-confirmation
                             :on-change   #(reset! password-confirmation %)
                             :placeholder (get-translation "login.reset-password.confirm-label" "Confirm password")
                             :disabled?   @loading?}]
            (when cognito?
              [:div.field
               [:input.m-input
                {:type          "text"
                 :placeholder   (get-translation "login.reset-password.verification-placeholder"
                                                 "6-digit verification code from email")
                 :aria-label    (get-translation "login.reset-password.verification-label"
                                                 "Verification Code")
                 :disabled      @loading?
                 :auto-complete "one-time-code"
                 :value         @verification-code
                 :on-change     #(reset! verification-code (.. % -target -value))}]])
            [submit-button
             (get-translation "login.reset-password.submit" "Reset your password")
             @loading?]
            [error-box @error]]
           [:div.reset-link-info
            [:strong (get-translation "login.reset-password.info-title" "About your reset link")]
            [:p (get-translation "login.reset-password.link-intro"
                                 "Your password reset link can be used only once. It will expire if:")]
            [:p (str "• " (get-translation "login.reset-password.link-bullet-1"
                                           "You try to reset your password more than once with the same link."))]
            [:p (str "• " (get-translation "login.reset-password.link-bullet-2"
                                           "You clicked \"Forgot your password?\" again and this is not the most recent link."))]
            [:p.reset-link-info__help
             (get-translation "login.reset-password.still-need-help" "Still need help? ")
             (get-translation "login.reset-password.contact-intro" "Request a new link or contact ")
             [:a {:href "mailto:support@practitest.com"}
              "support@practitest.com"]]]]]]))))
